"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResponseJson = createResponseJson;
exports.createResponseUnauthorised = createResponseUnauthorised;
exports.createResponseJsonError = createResponseJsonError;
exports.createResponseServerErrorWithApiResult = createResponseServerErrorWithApiResult;
exports.createResponseServerErrorNoApiResult = createResponseServerErrorNoApiResult;
function createResponseJson(json) {
    // Response is a large object so we just implement the parts we need and use a type assertion.
    return {
        json() {
            return Promise.resolve(json);
        },
        ok: true,
    };
}
function createResponseUnauthorised() {
    // Response is a large object so we just implement the parts we need and use a type assertion.
    return {
        json() {
            return Promise.reject("Example JSON Error");
        },
        ok: false,
        status: 401,
    };
}
function createResponseJsonError() {
    // Response is a large object so we just implement the parts we need and use a type assertion.
    return {
        json() {
            return Promise.reject("Example JSON Error");
        },
        ok: true,
    };
}
const apiResult = {
    message: "Example Message",
};
function createResponseServerErrorWithApiResult(statusCode = 400) {
    // Response is a large object so we just implement the parts we need and use a type assertion.
    return {
        json() {
            return Promise.resolve(apiResult);
        },
        ok: false,
        status: statusCode,
    };
}
function createResponseServerErrorNoApiResult(statusCode = 400) {
    // Response is a large object so we just implement the parts we need and use a type assertion.
    return {
        json() {
            return Promise.reject("Example JSON Error");
        },
        ok: false,
        status: statusCode,
    };
}
// Include full request and response type definitions for easy reference.
// const request : Request = {
//     arrayBuffer(): Promise<ArrayBuffer> {
//         return Promise.resolve(undefined);
//     },
//     blob(): Promise<Blob> {
//         return Promise.resolve(undefined);
//     },
//     body: undefined,
//     bodyUsed: false,
//     cache: undefined,
//     clone(): Request {
//         return undefined;
//     },
//     credentials: undefined,
//     destination: undefined,
//     formData(): Promise<FormData> {
//         return Promise.resolve(undefined);
//     },
//     headers: undefined,
//     integrity: "",
//     isHistoryNavigation: false,
//     isReloadNavigation: false,
//
//     keepalive: false,
//     method: "",
//     mode: undefined,
//     redirect: undefined,
//     referrer: "",
//     referrerPolicy: undefined,
//     signal: undefined,
//     text(): Promise<string> {
//         return Promise.resolve("");
//     },
//     url: ""
//
// };
// return request;
// const response : Response = {
//     arrayBuffer(): Promise<ArrayBuffer> {
//         return Promise.resolve(undefined);
//     }, blob(): Promise<Blob> {
//         return Promise.resolve(undefined);
//     }, body: undefined, bodyUsed: false, clone(): Response {
//         return undefined;
//     }, formData(): Promise<FormData> {
//         return Promise.resolve(undefined);
//     }, headers: undefined, json(): Promise<any> {
//         return Promise.resolve(undefined);
//     }, ok: false, redirected: false, status: 0, statusText: "", text(): Promise<string> {
//         return Promise.resolve("");
//     }, trailer: Promise.resolve(undefined), type: undefined, url: ""
//
// };
//# sourceMappingURL=TestFactory.js.map